import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { checkModifica, authLink } from 'app/utils/boolean-input';

@Component({
  selector: 'app-footer-links',
  standalone: true,
  imports: [MatIconModule, NgFor],
  templateUrl: './footer-links.component.html',
})
export class FooterLinksComponent {

    @Input() data:any;



    checkModificax(){
        return checkModifica()
    }


    authLink(url: string){
        return authLink(url)
    }



}
